import React from 'react';
import { motion } from 'framer-motion';
import About from './components/About.tsx';
import Skills from './components/Skills.tsx';
import Projects from './components/Projects.tsx';
import Contact from './components/Contact.tsx';
import Experience from './components/Experience.tsx';
import Certifications from './components/Certifications.tsx';



const App = () => {
  return (
    <div
      style={{
        background: 'linear-gradient(120deg, #e3f2fd 0%, #f7faff 100%)',
        minHeight: '100vh',
        fontFamily: 'Inter, Helvetica, Arial, sans-serif',
        width: '100%',
        boxSizing: 'border-box',
        overflowX: 'hidden',
      }}
    >
      {/* Hero Section */}
      <section
        style={{
          width: '100%',
          minHeight: '60vh',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          padding: '6vw 2vw 4vw 2vw',
          background: 'linear-gradient(90deg, #1565c0 0%, #2196f3 100%)',
          color: '#fff',
          boxShadow: '0 2px 16px rgba(21,101,192,0.08)',
        }}
      >
        {/* Profile photo at the top of banner */}
        <img
          src={require('./assets/profile.JPG')}
          alt="Profile"
          style={{
            width: '140px',
            height: '140px',
            borderRadius: '50%',
            border: '5px solid #fff',
            boxShadow: '0 8px 32px rgba(21,101,192,0.18)',
            objectFit: 'cover',
            marginBottom: '2vw',
          }}
        />
        <h1
          style={{
            fontSize: 'clamp(2.5rem, 7vw, 3.5rem)',
            fontWeight: 900,
            margin: 0,
            letterSpacing: '-2px',
            lineHeight: 1.1,
            textShadow: '0 2px 8px rgba(21,101,192,0.12)',
          }}
        >
          Shailesh Yadav
        </h1>
        <h2
          style={{
            fontSize: 'clamp(1.2rem, 3vw, 2rem)',
            fontWeight: 600,
            margin: '18px 0 0 0',
            color: '#e3f2fd',
            lineHeight: 1.2,
            textShadow: '0 2px 8px rgba(21,101,192,0.10)',
          }}
        >
          Front-End Developer
        </h2>
        <p
          style={{
            maxWidth: 600,
            margin: '32px auto 0 auto',
            fontSize: 'clamp(1rem, 2vw, 1.25rem)',
            color: '#e3f2fd',
            fontWeight: 400,
            letterSpacing: '0.5px',
            textAlign: 'center',
            lineHeight: 1.6,
            textShadow: '0 2px 8px rgba(21,101,192,0.08)',
          }}
        >
          I make delightful front-end magic — 8+ years turning ideas into fast, accessible web experiences. I love playful UI, smooth animations, and sneaking tiny performance wins into big apps.
        </p>
        {/* Removed Contact Me button from top banner */}
      </section>

      {/* Main Sections */}
      <main
        style={{
          maxWidth: '1100px',
          width: '100%',
          margin: '0 auto',
          padding: '6vw 2vw',
          boxSizing: 'border-box',
          overflowX: 'hidden',
        }}
      >
        <section style={{ marginBottom: '6vw' }}>
          <About />
        </section>
        <section style={{ marginBottom: '6vw' }}>
          <Skills />
        </section>
        <section style={{ marginBottom: '6vw' }}>
          <Projects />
        </section>
        <section style={{ marginBottom: '6vw' }}>
          <Experience />
        </section>
        <section style={{ marginBottom: '6vw' }}>
          <Certifications />
        </section>
        <section style={{ marginBottom: '6vw' }}>
          <Contact />
        </section>
      </main>

      {/* Footer */}
      <footer
        style={{
          width: '100%',
          background: '#1565c0',
          color: '#fff',
          textAlign: 'center',
          padding: '4vw 0',
          fontSize: 'clamp(0.9rem, 2vw, 1rem)',
          letterSpacing: '1px',
          marginTop: '4vw',
        }}
      >
        <div style={{ marginBottom: 8 }}>
          <a
            href="mailto:shaileshkyadav24@gmail.com"
            style={{
              color: '#e3f2fd',
              marginRight: 16,
              textDecoration: 'none',
              fontWeight: 600,
              fontSize: 'clamp(1rem, 2vw, 1.1rem)',
            }}
          >
            Email
          </a>
          <a
            href="https://linkedin.com/in/shaileshkyadav24"
            target="_blank"
            rel="noopener noreferrer"
            style={{
              color: '#e3f2fd',
              marginRight: 16,
              textDecoration: 'none',
              fontWeight: 600,
              fontSize: 'clamp(1rem, 2vw, 1.1rem)',
            }}
          >
            LinkedIn
          </a>
          <a
            href="https://github.com/shaileshyadav24"
            target="_blank"
            rel="noopener noreferrer"
            style={{
              color: '#e3f2fd',
              textDecoration: 'none',
              fontWeight: 600,
              fontSize: 'clamp(1rem, 2vw, 1.1rem)',
            }}
          >
            GitHub
          </a>
        </div>
        <div>
          &copy; {new Date().getFullYear()} Shailesh Yadav. All rights reserved.
        </div>
      </footer>
    </div>
  );
};

export default App;